import { render, staticRenderFns } from "./DocumentChecklistUploader.vue?vue&type=template&id=52a4cbf0&scoped=true"
import script from "./DocumentChecklistUploader.vue?vue&type=script&lang=js"
export * from "./DocumentChecklistUploader.vue?vue&type=script&lang=js"
import style0 from "./DocumentChecklistUploader.vue?vue&type=style&index=0&id=52a4cbf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a4cbf0",
  null
  
)

export default component.exports